export default "__VITE_ASSET__12215dc2__"